import React from 'react';
import { render } from 'react-dom';

import LoginForm from '../react/LoginForm';

export default class LoginFormRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model } = this.context.dataset;
    if (!apiUrl || !model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<LoginForm {...jsonModel} apiURL={apiUrl} />, this.context);
  }
}
